// extracted by mini-css-extract-plugin
module.exports = {"sizeActions":"product-details_sizeActions__gknlY","uspList":"product-details_uspList__NH8C5"};